<template>
    <div class="main">
        <img src="@/assets/images/logo.png" alt="logo" width="400" />
        <span class="loading-title">Please wait...</span>
    </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import '@/assets/css/main.css';
import {
    getQueryStringValue,
    combineCoordinatorUrl,
    persistUrlData,
    restoreUrlData,
} from '@/utils/helpers';
import ReconnectingWebSocket from 'reconnecting-websocket';
import * as protoMessages from '@/proto/Messages';
import ProtoService from '@/utils/services/ProtoService';
import AuthService from '@/utils/services/Auth';

const performAuth = async () => {
    const code = getQueryStringValue('code');
    const error = getQueryStringValue('error_description');

    if (error) {
        console.error(error);

        return Promise.reject(error);
    }

    if (!code) {
        persistUrlData();
        localStorage.setItem('authState', AuthService.state);

        AuthService.start();
    }

    if (localStorage.getItem('authState') !== getQueryStringValue('state')) {
        return Promise.reject();
    }

    restoreUrlData();

    const { access_token, refresh_token } = await AuthService.exchangeToken(code);
    localStorage.setItem('authAccessToken', access_token);
    localStorage.setItem('authRefreshToken', refresh_token);
};

onMounted(async () => {
    /** Uncomment when oauth flow will be finished **/
    // await performAuth();

    const socketUrl = combineCoordinatorUrl();
    const socket = new ReconnectingWebSocket(socketUrl);

    socket.onopen = () => {
        onOpen(socket);
    };

    socket.onmessage = message => {
        onMessage(message);
    };
});

const onOpen = (socket: any) => {
    const message = protoMessages.GeneralMessage.create();
    const messageType = protoMessages.MessageType.create();

    messageType.value = protoMessages.MessageType_Type.VERSION;

    message.messageType = messageType;

    const payload = {
        data: protoMessages.GeneralMessage.toBinary(message),
        type: 'ProtoMessages.GeneralMessage',
    };

    const msg = ProtoService.serializeProtoMessage(payload);

    socket.send(msg.buffer);
};

const onMessage = async (message: { data: Blob }) => {
    const parsedMessage = await ProtoService.deserializeProtoMessage(message.data);

    if (parsedMessage.type === 'ProtoMessages.GeneralMessage') {
        const deserializedMessage = ProtoService.deserializeGeneralProtoMessage(parsedMessage.data);

        if (deserializedMessage.type === protoMessages.MessageType_Type.VERSION) {
            const version = deserializedMessage.data?.versionMessage?.version;

            console.info('Version:', version);

            location.replace(
                `${location.protocol}//${location.host}/${version}/${location.search}`
            );
        }
    }
};
</script>
